import { ProblemDetails, ResponseWithBody, ResponseWrapper } from '../generated-service-lib';

export const getValidResponseDataOrThrow = <T>(
  response:
    | ResponseWithBody<200, ResponseWrapper<T, any>>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<401, ProblemDetails>
) => {
  if (response.status !== 200) throw Error('Request failed.');

  const responseData = response.body.data;
  if (typeof responseData === 'undefined') throw Error('No response data.');

  return responseData;
};

export const getValidResponseDataOrEmptyArray = <T extends any[]>(
  response:
    | ResponseWithBody<200, ResponseWrapper<T, any>>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<401, ProblemDetails>
): T => {
  if (response.status !== 200) return ([] as unknown) as T;

  const responseData = response.body.data;
  if (typeof responseData === 'undefined') return ([] as unknown) as T;

  return responseData;
};

export const assertSuccessfulResponse = <T>(
  response:
    | ResponseWithBody<200, ResponseWrapper<T, any>>
    | ResponseWithBody<200, void>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<401, ProblemDetails>
) => {
  if (response.status !== 200) throw Error('Request failed.');
};

export const getRandomString = (length = 10) => {
  // @ts-ignore
  const chars = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
  return [...Array(length)].map(() => chars[(Math.random() * chars.length) | 0]).join(``);
};

export const parseISODateStringToDate = (ISODateString: string): Date => {
  const dateTime = Date.parse(ISODateString);
  const dateObject = new Date(dateTime);

  return dateObject;
};
